import { render, staticRenderFns } from "./swipeBack.vue?vue&type=template&id=1d6b0648&scoped=true"
import script from "./swipeBack.vue?vue&type=script&lang=js"
export * from "./swipeBack.vue?vue&type=script&lang=js"
import style0 from "./swipeBack.vue?vue&type=style&index=0&id=1d6b0648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6b0648",
  null
  
)

export default component.exports